import request from '@/shared/api/request';

export const detachFirewallFromStacklet = (
  uuid: string,
  data: { stacklet_ids: number[] },
): Promise<void> =>
  request({
    url: `/firewalls/${uuid}/stacklets/`,
    method: 'DELETE',
    data,
  });
